<template>
  <div>
    <!--auto-resize  自动监听父元素的变化去重新计算表格（对于父元素可能存在动态变化、显示隐藏的容器中、列宽异常等场景中的可能会用到）-->
    <!--resizable  所有的列是否允许拖动列宽调整大小-->
    <!--keep-source  保持原始值的状态，被某些功能所依赖，比如编辑状态、还原数据等（开启后影响性能，具体取决于数据量）-->
    <vxe-grid
      auto-resize
      keep-source
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
    >
      <template v-slot:toolbar_form>
        <slot></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.userStatus === 'N'
              ? 'warning'
              : row.userStatus === 'S'
              ? 'danger'
              : row.userStatus === 'Y'
              ? 'success'
              : ''
          "
          >{{ row.userStatusName }}</el-tag
        >
      </template>
      <template v-slot:createInfo="{ row }">
        <div>
          <span>{{ row.createByName ? row.createByName : '--' }}</span>
          <br />
          <span>{{ row.createTime ? row.createTime : '--' }}</span>
        </div>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <div>
          <span>{{ row.modifyByName ? row.modifyByName : '--' }}</span>
          <br />
          <span>{{ row.modifyTime ? row.modifyTime : '--' }}</span>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button-group>
            <el-tooltip
              class="item"
              effect="dark"
              content="查看"
              placement="top"
            >
              <i
                class="el-icon-view tool-btn"
                @click="openEditPage({ pageType: 'detail', params: row })"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑"
              placement="top"
              v-allow="'actModify'"
              v-if="row.userStatus === 'Y'"
            >
              <i
                class="el-icon-edit tool-btn"
                @click="openEditPage({ pageType: 'edit', params: row })"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除"
              placement="top"
              v-allow="'actDel'"
              v-if="row.userStatus === 'Y'"
            >
              <i
                class="el-icon-delete tool-btn"
                @click="delRow(row.userCode, 'N')"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="重置密码"
              placement="top"
              v-allow="'actResetPwd'"
              v-if="row.userStatus === 'Y'"
            >
              <i
                class="el-icon-refresh tool-btn"
                @click="resetPwd(row.userCode)"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="停用"
              placement="top"
              v-allow="'actDisable'"
              v-if="row.userStatus === 'Y'"
            >
              <i
                class="el-icon-video-pause tool-btn"
                @click="delRow(row.userCode, 'S')"
              ></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="启用"
              placement="top"
              v-allow="'actEnable'"
              v-if="row.userStatus !== 'Y'"
            >
              <i
                class="el-icon-video-play tool-btn"
                @click="delRow(row.userCode, 'Y')"
              ></i>
            </el-tooltip>
          </b-button-group>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  data() {
    return {
      tableColumns: tableColumns(),
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: this.reload
        },
        zoom: true,
        custom: true
      },
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogSaveBtnVisible: true
      }
    }
  },
  created() {},
  destroyed() {},
  methods: {
    reload() {
      this.$emit('submit')
    },
    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'system-sysuser-detail',
        params: { ...params, pageType }
      })
    },
    resetPwd(userCode) {
      this.$api.sysUserResetPasswordApi({ userCode: userCode }).then((res) => {
        this.$message.success(res.msg)
      })
    },
    delRow(userCode, userStatus) {
      let msg = ''
      if (userStatus === 'Y') {
        msg = '是否启用'
      } else if (userStatus === 'N') {
        msg = '是否删除'
      } else if (userStatus === 'S') {
        msg = '是否停用'
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$api
          .sysUserUpdateStatusApi({
            userCode: userCode,
            userStatus: userStatus
          })
          .then((res) => {
            this.$message.success(res.msg)
            this.$emit('submit')
          })
      })
    }
  }
}
</script>
